<template>
	<div class="main-content" :style='{"color":"#666","padding":"20px 30px 30px","fontSize":"16px"}'>
		<!-- 列表页 -->
		<template v-if="showFlag">
			<el-form class="center-form-pv" :style='{"margin":"0 0 20px","fontSize":"inherit"}' :inline="true" :model="searchForm">
				<el-row :style='{"fontSize":"inherit","display":"block"}' >
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">标题</label>
						<el-input v-model="searchForm.title" placeholder="标题" @keydown.enter.native="search()" clearable></el-input>
					</div>
					<div :style='{"margin":"0 10px 0 0","fontSize":"inherit","display":"inline-block"}'>
						<label :style='{"margin":"0 10px 0 0","color":"inherit","display":"inline-block","lineHeight":"40px","fontSize":"inherit","fontWeight":"500","height":"40px"}' class="item-label">分类</label>
						<el-select v-model="searchForm.category" placeholder="请选择分类" clearable>
							<el-option label="全部" value=""></el-option>
							<el-option label="全职招聘" value="fulltime"></el-option>
							<el-option label="兼职招聘" value="parttime"></el-option>
							<el-option label="实习招聘" value="intern"></el-option>
							<el-option label="个人求职" value="jobsearch"></el-option>
						</el-select>
					</div>
					<el-button class="search" type="success" @click="search()">
						<span class="icon iconfont icon-yanziwancheng" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						搜索
					</el-button>
				</el-row>

				<el-row class="actions" :style='{"flexWrap":"wrap","margin":"20px 0","display":"flex"}'>
					<el-button class="add" type="success" @click="addOrUpdateHandler()">
						<span class="icon iconfont icon-kaitongfuwu" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						新增
					</el-button>
					<el-button class="del" :disabled="dataListSelections.length?false:true" type="danger" @click="deleteHandler()">
						<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff","height":"40px"}'></span>
						删除
					</el-button>
				</el-row>
			</el-form>
		<div :style='{"width":"100%","padding":"0","background":"none"}'>
			<el-table class="tables"
				:stripe='false'
				:style='{"padding":"0","borderColor":"#eee","color":"inherit","borderWidth":"1px 0 0 1px","background":"#fff","width":"100%","fontSize":"inherit","borderStyle":"solid"}' 
				:border='true'
				:data="dataList"
				:max-height="600"
				:row-style="{height: '60px'}"
				:cell-style="{padding: '15px 0'}"
				v-loading="dataListLoading"
				@selection-change="selectionChangeHandler">
					<el-table-column :resizable='true' type="selection" align="center" width="50"></el-table-column>
					<el-table-column :resizable='true' :sortable='true' label="序号" type="index" width="50" />
					<el-table-column :resizable='true' :sortable='true' prop="title" label="标题">
						<template slot-scope="scope">
							{{scope.row.title}}
						</template>
					</el-table-column>
					<el-table-column :resizable='true' :sortable='true' prop="category" label="分类">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.category == 'fulltime'" type="primary">全职招聘</el-tag>
							<el-tag v-else-if="scope.row.category == 'parttime'" type="success">兼职招聘</el-tag>
							<el-tag v-else-if="scope.row.category == 'intern'" type="info">实习招聘</el-tag>
							<el-tag v-else-if="scope.row.category == 'jobsearch'" type="warning">个人求职</el-tag>
						</template>
					</el-table-column>
				<el-table-column :resizable='true' :sortable='true' prop="username" label="发布人">
					<template slot-scope="scope">
						{{scope.row.username || '-'}}
					</template>
				</el-table-column>
				<el-table-column :resizable='true' :sortable='true' prop="commentCount" label="评论数">
					<template slot-scope="scope">
						{{scope.row.commentCount || 0}}
					</template>
				</el-table-column>
				<el-table-column :resizable='true' :sortable='true' prop="addtime" label="发布时间" width="160">
						<template slot-scope="scope">
							{{scope.row.addtime}}
						</template>
					</el-table-column>
					<el-table-column width="360" label="操作">
						<template slot-scope="scope">
							<div style="display: flex; gap: 8px; justify-content: center; align-items: center;">
								<el-button class="view" type="success" size="small" @click="addOrUpdateHandler(scope.row.id,'info')">
									<span class="icon iconfont icon-dagou" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff"}'></span>
									查看
								</el-button>
								<el-button class="edit" type="success" size="small" @click="addOrUpdateHandler(scope.row.id)">
									<span class="icon iconfont icon-bianji" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff"}'></span>
									修改
								</el-button>
								<el-button class="del" type="danger" size="small" @click="deleteHandler(scope.row.id)">
									<span class="icon iconfont icon-guanbi1" :style='{"margin":"0 2px","fontSize":"inherit","color":"#fff"}'></span>
									删除
								</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-pagination
				@size-change="sizeChangeHandle"
				@current-change="currentChangeHandle"
				:current-page="pageIndex"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="pageSize"
				:total="totalPage"
				layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</template>

		<!-- 添加/修改/查看页面 -->
		<add-or-update v-if="!showFlag" :parent="this" ref="addOrUpdate"></add-or-update>
	</div>
</template>

<script>
import AddOrUpdate from './add-or-update'
export default {
	data() {
		return {
			searchForm: {
				title: '',
				category: ''
			},
			dataList: [],
			pageIndex: 1,
			pageSize: 10,
			totalPage: 0,
			dataListLoading: false,
			dataListSelections: [],
			showFlag: true
		}
	},
	components: {
		AddOrUpdate
	},
	mounted() {
		// 页面首次加载时获取数据
		console.log('残友招聘管理页面已加载，开始获取数据...')
		this.search()
	},
	activated() {
		// keep-alive缓存后再次激活时获取数据
		console.log('残友招聘管理页面已激活，刷新数据...')
		this.search()
	},
	methods: {
		search() {
			this.pageIndex = 1
			this.getDataList()
		},
		// 获取数据列表
		getDataList() {
			console.log('开始获取数据列表，页码:', this.pageIndex, '每页数量:', this.pageSize)
			this.dataListLoading = true
			let params = {
				page: this.pageIndex,
				limit: this.pageSize,
				sort: 'addtime',
				order: 'desc'
			}
			if (this.searchForm.title) {
				params['title'] = '%' + this.searchForm.title + '%'
			}
			if (this.searchForm.category) {
				params['category'] = this.searchForm.category
			}
			console.log('请求参数:', params)
			this.$http({
				url: 'recruitmentPost/page',
				method: 'get',
				params: params
			}).then(({data}) => {
				console.log('API返回数据:', data)
				if (data && data.code === 0) {
					// 修复：后端返回的是 data.data，不是 data.page
					this.dataList = data.data.list ? [...data.data.list] : []
					this.totalPage = data.data.totalCount
					console.log('数据加载成功，共', this.totalPage, '条记录')
					console.log('dataList:', this.dataList)
				} else {
					this.dataList = []
					this.totalPage = 0
					console.error('API返回错误:', data)
					this.$message.error(data.msg || '获取数据失败')
				}
				this.dataListLoading = false
			}).catch(error => {
				console.error('API请求失败:', error)
				this.dataList = []
				this.totalPage = 0
				this.dataListLoading = false
				this.$message.error('网络请求失败，请检查后端服务是否正常运行')
			})
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
		// 多选
		selectionChangeHandler(val) {
			this.dataListSelections = val
		},
		// 添加/修改
		addOrUpdateHandler(id, type) {
			this.showFlag = false
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id, type)
			})
		},
		// 删除
		deleteHandler(id) {
			var ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			this.$confirm(`确定要删除这${ids.length}条记录吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: 'recruitmentPost/delete',
					method: 'post',
					data: ids
				}).then(({data}) => {
					if (data && data.code === 0) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.search()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				})
			}).catch(() => {})
		}
	}
}
</script>
<style lang="scss" scoped>
/* 表格行高优化 */
.tables ::v-deep .el-table__body-wrapper {
	overflow-y: auto;
}

.tables ::v-deep .el-table__row {
	height: 60px;
}

.tables ::v-deep .el-table__cell {
	padding: 15px 0;
}

/* 操作按钮优化 */
.tables ::v-deep .el-button--small {
	padding: 8px 12px;
	font-size: 13px;
}

/* 表格内容垂直居中 */
.tables ::v-deep .cell {
	display: flex;
	align-items: center;
	justify-content: center;
}

/* 标题列左对齐 */
.tables ::v-deep .el-table__body .cell {
	padding: 0 10px;
}
</style>

